import { EIssueSeverity } from '@/core/modules/issues/constants'

export interface IssuesCount {
    critical: number
    important: number
    moderate: number
}

export const getHighestSeverity = (
    issues?: Array<{ status: string; severity: string }>
): TIssueSeverity => {
    const openIssues = issues?.filter((issue) => issue.status === 'open') || []

    if (openIssues.length === 0) {
        return 'clean'
    }

    const sortedIssues = openIssues.sort(
        (a, b) =>
            EIssueSeverity[b.severity as keyof typeof EIssueSeverity] -
            EIssueSeverity[a.severity as keyof typeof EIssueSeverity]
    )

    return sortedIssues[0].severity as TIssueSeverity
}

export const countIssuesBySeverity = (
    issues?: TIssue[]
): IssuesCount => {
    const openIssues = issues?.filter((issue) => issue.status === 'open') || [] as TIssue[]

    const { becIssues, nonBecIssues } = openIssues.reduce<{ becIssues: TIssue[], nonBecIssues: TIssue[] }>((acc, issue) => {
        if (issue.issue_type === 'INBOX_RULE') {
            acc.becIssues.push(issue)
        } else {
            acc.nonBecIssues.push(issue)
        }
        return acc
    }, { becIssues: [], nonBecIssues: [] })

    const counts = nonBecIssues.reduce(
        (acc, issue) => {
            if (issue.severity === 'critical') {
                acc.critical++
            } else if (issue.severity === 'important') {
                acc.important++
            } else if (issue.severity === 'moderate') {
                acc.moderate++
            }
            return acc
        },
        { critical: 0, important: 0, moderate: 0 }
    )

    // If there are any BEC issues, count them as 1 as critical severity
    if (becIssues.length > 0) {
        counts.critical++
    }

    return counts
}

export const SEVERITY_TEXT_MAPPING: Record<TIssueSeverity, string> = {
    critical: 'Critical',
    important: 'Important',
    moderate: 'Moderate',
    clean: 'Excellent',
}
